import React from "react";

export function SearchIcon({
  size = 16,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      style={{ color, ...style }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19C11.7631 19 13.8415 18.2086 15.4733 16.8875L20.293 21.7072L21.7072 20.293L16.8875 15.4733C18.2086 13.8415 19 11.7631 19 9.5C19 4.25329 14.7467 0 9.5 0ZM2 9.5C2 5.35786 5.35786 2 9.5 2C13.6421 2 17 5.35786 17 9.5C17 13.6421 13.6421 17 9.5 17C5.35786 17 2 13.6421 2 9.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SearchActiveIcon({
  size = 16,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      style={{ color, ...style }}
      {...props}
    >
      <path
        d="M10.6667 6.33333C10.6667 8.72657 8.72657 10.6667 6.33333 10.6667C3.9401 10.6667 2 8.72657 2 6.33333C2 3.9401 3.9401 2 6.33333 2C8.72657 2 10.6667 3.9401 10.6667 6.33333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.33333C0 2.83553 2.83553 0 6.33333 0C9.83114 0 12.6667 2.83553 12.6667 6.33333C12.6667 7.8421 12.1391 9.22764 11.2584 10.3155L14.4715 13.5286L13.5286 14.4715L10.3155 11.2584C9.22764 12.1391 7.8421 12.6667 6.33333 12.6667C2.83553 12.6667 0 9.83114 0 6.33333ZM6.33333 1.33333C3.57191 1.33333 1.33333 3.57191 1.33333 6.33333C1.33333 9.09476 3.57191 11.3333 6.33333 11.3333C9.09476 11.3333 11.3333 9.09476 11.3333 6.33333C11.3333 3.57191 9.09476 1.33333 6.33333 1.33333Z"
        fill="currentColor"
      />
    </svg>
  );
}
